import React from "react";
import { Button, Icon } from "semantic-ui-react";

export const PrevButton = props => (
  <Button animated {...props}>
    <Button.Content hidden>Prev</Button.Content>
    <Button.Content visible>
      <Icon name="left arrow" />
    </Button.Content>
  </Button>
);

export const NextButton = props => (
  <Button animated {...props}>
    <Button.Content hidden>Next</Button.Content>
    <Button.Content visible>
      <Icon name="right arrow" />
    </Button.Content>
  </Button>
);
